/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EvmGeneralInfo } from '../models/EvmGeneralInfo';
import type { EvmGeneralSummaryInfo } from '../models/EvmGeneralSummaryInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmGeneralControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns EvmGeneralSummaryInfo OK
     * @throws ApiError
     */
    public getEvmGeneralSummary(): CancelablePromise<EvmGeneralSummaryInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/general/summary',
        });
    }

    /**
     * @returns EvmGeneralSummaryInfo OK
     * @throws ApiError
     */
    public getEvmGeneralSummary1(): CancelablePromise<EvmGeneralSummaryInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/general/summary',
        });
    }

    /**
     * @returns EvmGeneralInfo OK
     * @throws ApiError
     */
    public getEvmGeneral({
        types,
    }: {
        types: string,
    }): CancelablePromise<EvmGeneralInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/general',
            query: {
                'types': types,
            },
        });
    }

    /**
     * @returns EvmGeneralInfo OK
     * @throws ApiError
     */
    public getEvmGeneral1({
        types,
    }: {
        types: string,
    }): CancelablePromise<EvmGeneralInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/general',
            query: {
                'types': types,
            },
        });
    }

}
